type CongestionManagementTextProps = {
  congestionType: string | undefined | null;
  supplyResearchCongestionManagementText: string | undefined | null;
  consumeResearchCongestionManagementText: string | undefined | null;
};

export const getCongestionManagementText = ({
  congestionType,
  supplyResearchCongestionManagementText,
  consumeResearchCongestionManagementText,
}: CongestionManagementTextProps) => {
  switch (congestionType) {
    case 'Teruglevering':
      return supplyResearchCongestionManagementText;
    case 'Verbruik':
      return consumeResearchCongestionManagementText;
    default:
      return null;
  }
};

